/**
 * Generates initials from a full name string.
 *
 * @param {string} name - The full name string.
 * @returns {string} The initials (e.g., "HG") or an empty string if the name is invalid.
 *
 * @example
 * getInitials("Hritik Gandhi") // returns "HG"
 * getInitials("SingleName") // returns "S"
 * getInitials("  leading space ") // returns "LS"
 * getInitials("") // returns ""
 * getInitials(null) // returns ""
 */
export const getInitials = (name) => {
  if (!name || typeof name !== "string") {
    return "";
  }

  const nameParts = name
    .trim()
    .split(" ")
    .filter((part) => part.length > 0);

  if (nameParts.length === 0) {
    return "";
  }

  if (nameParts.length === 1) {
    return nameParts[0][0].toUpperCase();
  }

  // Take the first letter of the first and last parts
  return (
    nameParts[0][0].toUpperCase() +
    nameParts[nameParts.length - 1][0].toUpperCase()
  );
};
